export default {
  badge: 'बिल्ला',
  close: 'बंद करना',
  dataIterator: {
    noResultsText: 'कोई मिलान रिकॉर्ड पाया',
    loadingText: 'आइटम लोड हो रहे हैं...',
  },
  dataTable: {
    itemsPerPageText: 'पंक्तियाँ प्रति पृष्ठ:',
    ariaLabel: {
      sortDescending: 'अवरोही क्रमबद्ध करें।',
      sortAscending: 'आरोही क्रमबद्ध करें।',
      sortNone: 'क्रमबद्ध नहीं।',
      activateNone: 'छँटाई हटाने के लिए सक्रिय करें।',
      activateDescending: 'अवरोही क्रमबद्ध करने के लिए सक्रिय करें।',
      activateAscending: 'आरोही क्रमबद्ध करने के लिए सक्रिय करें।',
    },
    sortBy: 'इसके अनुसार क्रमबद्ध करें',
  },
  dataFooter: {
    itemsPerPageText: 'आइटम प्रति पेज:',
    itemsPerPageAll: 'सभी',
    nextPage: 'अगला पृष्ठ',
    prevPage: 'पिछला पृष्ठ',
    firstPage: 'पहला पन्ना',
    lastPage: 'अंतिम पृष्ठ',
    pageText: '{2} में से {0}-{1}',
  },
  datePicker: {
    itemsSelected: '{0} चयनित',
    nextMonthAriaLabel: 'अगले महीने',
    nextYearAriaLabel: 'अगले वर्ष',
    prevMonthAriaLabel: 'पिछला महीना',
    prevYearAriaLabel: 'Previous year',
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'पिछला दृश्य',
    next: 'अगला दृश्य',
    ariaLabel: {
      delimiter: '{1} में से हिंडोला स्लाइड {0}',
    },
  },
  calendar: {
    moreEvents: '{0} और',
  },
  fileInput: {
    counter: '{0} फ़ाइलें',
    counterSize: '{0} फ़ाइलें (कुल {1})',
  },
  timePicker: {
    am: 'पूर्वाह्न',
    pm: 'बजे',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'पेजिनेशन नेविगेशन',
      next: 'अगला पृष्ठ',
      previous: 'पिछला पृष्ठ',
      page: 'गोटो पृष्ठ {0}',
      currentPage: 'वर्तमान पृष्ठ, पृष्ठ {0}',
    },
  },
  rating: {
    ariaLabel: {
      icon: '{1} में से {0} रेटिंग',
    },
  },
};
